import { goldTypes } from '@/mocks/goldPrices';
import PriceChange from '@/components/base/PriceChange';

function formatVnd(value: number) {
  return value.toLocaleString('vi-VN') + 'đ';
}

export default function GoldPriceTable({ limit }: { limit?: number }) {
  const items = limit ? goldTypes.slice(0, limit) : goldTypes;

  return (
    <div className="overflow-x-auto rounded-xl border border-background-200/60">
      <table className="w-full text-sm min-w-[640px]">
        <thead>
          <tr className="bg-background-100 text-left">
            <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Loại vàng</th>
            <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600 text-right">Giá mua</th>
            <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600 text-right">Giá bán</th>
            <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600 text-right">Thay đổi</th>
          </tr>
        </thead>
        <tbody>
          {items.map((g) => (
            <tr key={g.id} className="border-t border-background-200/40 hover:bg-background-100/60 transition-colors">
              <td className="px-4 py-3">
                <div className="flex items-center gap-2.5">
                  <div className="w-8 h-8 rounded-md bg-primary-500/15 flex items-center justify-center">
                    <i className="ri-copper-coin-line text-primary-400 text-base"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-foreground-950 whitespace-nowrap">{g.name}</p>
                    <p className="text-xs text-foreground-600">{g.code} · {g.unit}</p>
                  </div>
                </div>
              </td>
              <td className="px-4 py-3 text-right font-semibold text-foreground-900 whitespace-nowrap">{formatVnd(g.buy)}</td>
              <td className="px-4 py-3 text-right font-semibold text-foreground-900 whitespace-nowrap">{formatVnd(g.sell)}</td>
              <td className="px-4 py-3 text-right">
                <PriceChange change={g.change} changePercent={g.changePercent} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}